import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=56ce74d8&scoped=true&"
import script from "./BillingAddress.vue?vue&type=script&lang=js&"
export * from "./BillingAddress.vue?vue&type=script&lang=js&"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=56ce74d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce74d8",
  null
  
)

export default component.exports